import { SectionWithWidth } from '../SectionWithWidth';

export const getSectionPerimeter = (section: SectionWithWidth): number =>
  (section.displayedSurface / section.width) * 2 + section.width * 2;
